import React from "react";
import styles from "./Wrapper.module.scss";

const Wrapper = ({ children, grid }) => {
  return (
    <div className={`${styles.detailscont} ${grid ? styles.grid : ""}`}>
      <div className={styles.subCont}>{children}</div>
    </div>
  );
};

export default Wrapper;
